import { configureStore } from '@reduxjs/toolkit'
import toggleReducer from './slice/changeState'

const store = configureStore({
    reducer: {
        toggle: toggleReducer,
        // master : masterReducer,
    },
})
export default store;